import { map, mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { INotificationApiDependencySegment } from '@cbridge-packages/api-notifications';
import { catchApiError } from '@cbridge-packages/api-base';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { AlertTranslator } from '@cbridge-packages/alert';
import { AlertSubscriptionAction } from '../alertSubscription.action';

type IDependencies = INotificationApiDependencySegment;

export const updateSubscriptionEpic: IEpic<{}, IDependencies> = (action$, _state$, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(AlertSubscriptionAction.updateSubscription.started),
  mergeMap((payload) => dependencies.nsApi.updateSubscription(AlertTranslator.toApiAlertType(payload.type), { enabled: payload.enabled })
    .pipe(
      map(() => AlertSubscriptionAction.updateSubscription.done({ params: payload, result: undefined })),
      catchApiError((error) => [
        AlertSubscriptionAction.updateSubscription.failed({ params: payload, error }),
        createApiErrorNotification(error),
      ]),
    )),
);
